import Vue from 'vue';

import { app } from '../app.js';

new Vue({
    el: '#template-cart',

    delimiters: ['${', '}'],

    data: {
    },

    computed: {
        cart() {
            return app.cart;
        }
    },

    methods: {
        updateQuantity(...args) {
            app.updateQuantity(...args);
        }
    }
});